<template>
  <block-item-card
    :min-height="150"
    :title="$t('RiskLiquidity.Section.DefenceReadiness.CrisisScenarios.Title')"
    :tooltip="$t('RiskLiquidity.Section.DefenceReadiness.CrisisScenarios.InfoTip')"
  >
    <div
      class="pa-5 d-flex align-center"
      style="height: 100%;"
    >
      <v-row no-gutters>
        <v-col
          v-for="crisis in crisisScenarios"
          :key="crisis.type"
          cols="12"
          md="4"
          class="pr-md-2 mt-2 mt-md-0"
        >
          <div
            :class="[
              'crisis-card',
              'd-flex',
              'cursor-pointer',
              'transition-swing ',
            ]"
            :style="{
              height: '128px',
              border: '1px solid var(--v-synthesis-ui-grey-02-base)',
              borderRadius: '10px',
              boxShadow: activeCrisisScenario(crisis.Type) ? '12px 12px 16px 0px rgba(61, 104, 213, 0.12)' : 'none'
            }"

            class="pa-1"
            :elevation="0"
            @click="selectCrisis(crisis.Type)"
          >
            <div class="d-flex flex-column justify-space-between">
              <div class="d-flex flex-row align-center">
                <crisis-scenario-icon
                  :name="crisis.Type"
                  :size="70"
                />
                <div
                  class="scenario-title"
                  :style="{
                    color: activeCrisisScenario(crisis.Type) ? 'var(--v-synthesis-ui-blue-04-base)' : 'var(--v-synthesis-ui-grey-01-base)'
                  }"
                >
                  {{ crisis.Title }}
                </div>
              </div>

              <div
                class="scenario-subtitle"
                :style="{
                  color: activeCrisisScenario(crisis.Type) ? 'var(--v-synthesis-ui-blue-04-base)' : 'var(--v-synthesis-ui-grey-01-base)'
                }"
              >
                {{ crisis.Bank }}
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </block-item-card>
</template>

<script>
import BlockItemCard from '@/theme/default/components/common/BlockItemCard'
import CrisisScenarioIcon from '@/theme/default/components/common/icons/CrisisScenarioIcon'
import CrisisScenarioEnum from '@/api/enums/CrisisScenarioEnum'

export default {
  name      : 'CrisisScenarios',
  components: {
    BlockItemCard,
    CrisisScenarioIcon
  },
  dataStore: {
    CrisisScenario  : 'RiskLiquidity.CrisisScenario.Data',
    SelectedScenario: 'RiskLiquidity.CrisisScenario.SelectedScenario'
  },
  data () {
    return {
      isEditedScenario: false
    }
  },
  computed: {
    crisisScenarios () {
      // Convert to array
      return Object.values(this.$t('RiskLiquidity.Section.DefenceReadiness.CrisisScenarios.Scenarios'))
    },
    selectedScenario () {
      return this.SelectedScenario
    }
  },
  created () {
    // Listen for deselect all scenarios event
    this.$bus.$on('RiskLiquidity:CrisisScenario:DeselectAll', this.deselectAllScenarios)
    this.$bus.$on('liquidity:cancel-assumptions-edit', () => this.selectCrisis(CrisisScenarioEnum.Panic))
    this.$bus.$on('liquidity: rerun', () => this.selectCrisis(CrisisScenarioEnum.Panic))
  },
  beforeDestroy () {
    this.$bus.$off('RiskLiquidity:CrisisScenario:DeselectAll', this.deselectAllScenarios)
    this.$bus.$off('liquidity:cancel-assumptions-edit', () => this.selectCrisis(CrisisScenarioEnum.Panic))
    this.$bus.$off('liquidity: rerun', () => this.selectCrisis(CrisisScenarioEnum.Panic))
  },
  mounted () {},
  methods: {
    selectCrisis (crisisType) {
      this.SelectedScenario = crisisType
      this.isEditedScenario = false
      // Emit global event so parent containers can react
      this.$bus.$emit('RiskLiquidity:CrisisScenario:Changed', crisisType)
    },
    activeCrisisScenario (type) {
      return this.SelectedScenario === type && !this.isEditedScenario
    },
    deselectAllScenarios () {
      this.isEditedScenario = true
      this.SelectedScenario = null
    }
  }
}
</script>

<style scoped>
.crisis-card {
  transition: all 0.3s ease;
}

.crisis-card:hover {
  transform: translateY(-2px);
}

.cursor-pointer {
  cursor: pointer;
}

.scenario-title {
  color: var(--v-synthesis-ui-grey-01-base);
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.2px;
  line-height: 24px;
  top: -3px;
  position: relative;
  margin-left: 5px;
}

.scenario-subtitle {
  color: var(--v-synthesis-ui-grey-01-base);
  font-size: 10px;
  font-weight: 400;
  letter-spacing: -0.2px;
  line-height: 20px;
  margin-left: 10px
}
</style>
